import { Helmet } from 'react-helmet-async';

const defaultTitle = 'KK Solar - Best Solar Company in Kutch, Gujarat | Rooftop Solar Installation';
const defaultDescription = 'KK Solar is the leading solar company in Kutch, Gujarat. Get rooftop solar installation with up to ₹78,000 subsidy. Residential, commercial & industrial solar solutions.';
const defaultUrl = 'https://kksolar.co.in';
const defaultImage = 'https://kksolar.co.in/logo192.png';

const Seo = ({
  title = defaultTitle,
  description = defaultDescription,
  url = defaultUrl,
  image = defaultImage,
  type = 'website',
  children,
}) => (
  <Helmet>
    <title>{title}</title>
    <meta name="description" content={description} />
    <meta name="robots" content="index, follow" />
    <link rel="canonical" href={url} />

    <meta property="og:type" content={type} />
    <meta property="og:title" content={title} />
    <meta property="og:description" content={description} />
    <meta property="og:url" content={url} />
    <meta property="og:image" content={image} />
    <meta property="og:site_name" content="KK Solar" />
    <meta property="og:locale" content="en_IN" />

    <meta property="twitter:card" content="summary_large_image" />
    <meta property="twitter:title" content={title} />
    <meta property="twitter:description" content={description} />
    <meta property="twitter:image" content={image} />

    {children}
  </Helmet>
);

export default Seo;
